module.exports = __webpack_public_path__ + "static/media/eurobanan.e4fbcf01.jpeg";